import { forwardRef as g, useRef as A, useEffect as T } from "react";
import { useThemeUI as d, Textarea as v } from "theme-ui";
import { useDerivedState as S, mergeRefs as V } from "@material-bank/ds-utils";
import { Input as C } from "../Input.js";
import { jsx as R } from "theme-ui/jsx-runtime";
const y = g((s, u) => {
  var i;
  const {
    variant: t = "filled",
    value: l,
    defaultValue: f,
    autoSize: a = !1,
    error: n,
    onTextChange: p,
    containerSx: x,
    sx: m,
    ...c
  } = s, [o, h] = S({
    value: l,
    initialValue: f ?? "",
    onChange: p
  }), {
    theme: r
  } = d(), e = A(null);
  return T(() => {
    a && e.current && (e.current.style.height = "inherit", e.current.style.height = `${e.current.scrollHeight}px`);
  }, [a, o]), /* @__PURE__ */ R(C, {
    ref: V(u, e),
    ...c,
    variant: t,
    Component: v,
    value: o,
    error: n,
    onTextChange: h,
    containerSx: {
      ...r.textAreaWrapper[t],
      ...n && ((i = r.textAreaWrapperVariantState[t]) == null ? void 0 : i.error),
      ...x
    },
    sx: {
      resize: "none",
      height: "unset",
      ...r.textArea[t],
      ...m
    }
  });
});
y.displayName = "TextArea";
export {
  y as TextArea
};
